import { faDigits } from '../../lib/faDigits.ts';

/** `2210/1` is 2210. Any other exact fraction stays a fraction. */
export function formatStockOnHand(onHand: string): string {
  const match = /^(-?\d+)\/(-?\d+)$/.exec(onHand.trim());
  if (!match) return onHand;
  const numerator = match[1] ?? onHand;
  const denominator = match[2];
  if (denominator === '1') return numerator;
  return `${numerator}/${denominator}`;
}

export function stockEvidenceLabel(item: {
  readonly recordId: string;
  readonly onHand: string;
  readonly label?: string | null;
}): string {
  const name = item.label?.trim() ?? '';
  const title = name === '' ? item.recordId : `${name} (${item.recordId})`;
  return `${title}: ${faDigits(formatStockOnHand(item.onHand))} عدد`;
}
